import { initMercadoPago } from "@mercadopago/sdk-react";

let initialized = false;

interface MercadoPagoConfig {
  publicKey: string;
  locale?: "es-AR" | "es-MX" | "pt-BR" | "en-US";
}

function initMercadoPagoGateway(config: MercadoPagoConfig | string): void {
  if (initialized) {
    console.warn("MercadoPago already initialized");
    return;
  }

  const publicKey = typeof config === "string" ? config : config.publicKey;

  if (!publicKey) {
    console.warn("Missing MercadoPago Public Key. Payment gateway will not be initialized.");
    return;
  }

  try {
    initMercadoPago(publicKey, {
      locale: typeof config === "object" ? config.locale : undefined,
    });
    initialized = true;
    console.log("MercadoPago initialized successfully");
  } catch (error) {
    console.error("Error initializing MercadoPago:", error);
  }
}

/**
 * Inicializa MercadoPago desde configuración en window
 */
export function ensureMercadoPagoInitialized(): void {
  if (initialized) return;

  const publicKey = (window as any)?.APP_CONFIG?.MERCADOPAGO_PUBLIC_KEY;

  if (!publicKey) {
    console.warn("Missing MercadoPago Public Key (MERCADOPAGO_PUBLIC_KEY).");
    return;
  }

  initMercadoPagoGateway(publicKey);
}


